export const getLogoTarget = ({ role, isAuthenticated }) => {
    // Si non authentifie ou pas de role
    if (!isAuthenticated || !role) {
        return "/admin/login";
    }

    // Redirection selon le role
    if (role === "SUPER_ADMIN" || role === "ADMIN") {
        return "/admin/pilotage/dashboard";
    }

    if (role === "RH") {
        return "/admin/recrutement/dashboard";
    }

    if (role === "COLLAB") {
        return "/collab";
    }

    // Fallback
    return "/admin/login";
};
